import Button from "../../base/Button";

const renderIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="24"
        viewBox="0 0 14 24"
    >
        <g fill="none" fillRule="evenodd" stroke="#FFF" strokeWidth="2">
            <path d="M7.235 2v20" />
            <path
                strokeLinecap="square"
                d="M12.235 17l-5 5-5-5M2.235 7l5-5 5 5"
            />
        </g>
    </svg>
);

/**
 * Toolbar button for highlighting a column of lights.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered column button.
 */
const ColumnButton = (props) => <Button {...props} renderIcon={renderIcon} />;

export default ColumnButton;
